export const VISION_DESIGN_PERMISSION = {
  service_bureau_admin: `service_bureau_admin`,
  service_bureau_user: `service_bureau_user`,
  vision_admin: `vision_admin`,
  vision_designer_user: `vision_designer_user`,
  vision_developer: `vision_developer`,
  vision_proposal_admin: `vision_proposal_admin`,
  vision_service_bureau_admin: `vision_service_bureau_admin`,
  vision_service_bureau_user: `vision_service_bureau_user`,
  tier_2_vision_designer: `tier_2_vision_designer`,
  can_view_enterprise_proposal_pricing_breakdown: `can_view_enterprise_proposal_pricing_breakdown`,
  enterprise_admin: `enterprise_admin`,
  enterprise_manager: `enterprise_manager`,
}

type PermissionTemp =
  (typeof VISION_DESIGN_PERMISSION)[keyof typeof VISION_DESIGN_PERMISSION]

export const canSelfDesign = (permissions: PermissionTemp[]): boolean => {
  const canSelfDesign = permissions.some(
    (permission) =>
      permission === VISION_DESIGN_PERMISSION.vision_designer_user ||
      permission === VISION_DESIGN_PERMISSION.vision_admin,
  )

  return canSelfDesign
}

export const canRejectDesignRequest = (
  permissions: PermissionTemp[],
): boolean => {
  const canRejectDesignRequest = permissions.some(
    (permission) =>
      permission === VISION_DESIGN_PERMISSION.service_bureau_user ||
      permission === VISION_DESIGN_PERMISSION.service_bureau_admin ||
      permission === VISION_DESIGN_PERMISSION.vision_service_bureau_user ||
      permission === VISION_DESIGN_PERMISSION.vision_service_bureau_admin ||
      permission === VISION_DESIGN_PERMISSION.tier_2_vision_designer,
  )

  return canRejectDesignRequest
}

export const canViewFullBreakdown = (permissions: PermissionTemp[]): boolean => {
  const canViewFullBreakdown = permissions.some(
    (permission) =>
      permission ===
        VISION_DESIGN_PERMISSION.can_view_enterprise_proposal_pricing_breakdown ||
      permission === VISION_DESIGN_PERMISSION.vision_admin ||
      permission === VISION_DESIGN_PERMISSION.vision_proposal_admin ||
      permission === VISION_DESIGN_PERMISSION.vision_developer,
  )

  return canViewFullBreakdown
}
